import React, { Component } from 'react';

import { IsListEmpty } from '../../../utilities/CommonMethods';
import classes from './HorizontalTabs.module.css';

import HorizontalTabNextBlue from '../../../assets/icons/arrow-right.svg';
import HorizontalTabBackBlue from '../../../assets/icons/arrow-left.svg';

class HorizontalTabs extends Component {
    refsCollection = [];
    currentTab = 0;
    showArrows = false;

    onTabClick = (pos) => {
        //console.log('TabList: ', this.props.tabList)
        let position = 0;
        if (!IsListEmpty(this.props.tabList)) {
            for (let item in this.props.tabList) {
                if (this.props.tabList[item].id === pos) {
                    position = item;
                    this.currentTab = parseInt(position, 10);
                }
            }
        }

        if (!IsListEmpty(this.props.tabList)) {
            const leftOffset = this.refsCollection[position].getBoundingClientRect().left;
            //console.log('current tab: ', this.currentTab, pos, leftOffset, this.tabList.scrollLeft);
            if (leftOffset > 0 && position >= 2) {
                this.tabList.scrollLeft += this.refsCollection[position].getBoundingClientRect().width;
            } else {
                this.tabList.scrollLeft -= this.refsCollection[position].getBoundingClientRect().width;
            }
        }

        if (this.currentTab === 0) {
            //console.log('Reached to first element')
        }
        if (this.currentTab === this.props.tabList.length - 1) {
            //console.log('Reached to last element')
        }
        this.props.onTabClick(pos);
    }

    onTabNextClick = () => {
        if (this.currentTab === (this.props.tabList.length - 1)) return;
        let position = this.currentTab + 1;

        if (!IsListEmpty(this.props.tabList)) {
            const leftOffset = this.refsCollection[position].getBoundingClientRect().left;
            if (leftOffset > 0) {
                this.tabList.scrollLeft += this.refsCollection[position].getBoundingClientRect().width;
            }
        }
        //console.log('Next Click', this.currentTab, position, this.props.tabList.length)
        this.props.onTabClick(position + 2);
        this.currentTab += 1;

        if (this.currentTab === 0) {
            //console.log('Reached to first element')
        }
        if (this.currentTab === this.props.tabList.length - 1) {
            //console.log('Reached to last element')
        }
    }

    onTabBackClick = () => {

        if (this.currentTab === 0) return;

        let position = this.currentTab - 1;

        if (!IsListEmpty(this.props.tabList)) {
            const leftOffset = this.refsCollection[position].getBoundingClientRect().left;
            if (leftOffset < 0) {
                this.tabList.scrollLeft -= this.refsCollection[position].getBoundingClientRect().width;
            }
        }
        //console.log('Back Click', this.currentTab, position)
        this.props.onTabClick(position + 2);
        this.currentTab -= 1;

        if (this.currentTab === 0) {
            //console.log('Reached to first element')
            this.tabList.scrollLeft = 0;
        }
        if (this.currentTab === this.props.tabList.length - 1) {
            //console.log('Reached to the last element')
        }

    }

    componentDidMount() {
        let mobileDevice = (document.documentElement.clientWidth < 992) ? true : false;
        if (!mobileDevice) {
            if (this.tabList !== undefined && this.tabList !== '') {
                (this.tabList.scrollWidth > this.tabList.offsetWidth ? this.showArrows = true : this.showArrows = false);
            }
        }
        // //console.log('Show Arrows on component mounted: ', this.showArrows, this.tabList.scrollWidth, this.tabList.offsetWidth, this.tabList.scrollLeft);
    }


    render() {
        let styleClasses = [classes.Tabs];

        if (this.props.styleclass !== undefined) {
            const styles = this.props.styleclass.split(' ');
            for (let style in styles) {
                styleClasses.push(classes[styles[style].trim()]);
            }
        }

        const tabs = this.props.tabList.map((item, pos) => {
            return (
                <h3
                    key={pos}
                    className={[classes.TabItem, (this.props.currentTabId === item.id ? classes.Active : null)].join(' ')}
                    ref={(instance) => { this.refsCollection.push(instance) }}
                    onClick={() => this.onTabClick(item.id)}
                >
                    {item.label}
                </h3>
            )
        })

        return (
            <div className={classes.TabListContainer}>
                {this.showArrows ?
                    this.currentTab === 0 ? null :
                        <div onClick={this.onTabBackClick} className={classes.TabButtonBack}>
                            <img src={HorizontalTabBackBlue} alt="Back Blue" />
                        </div>
                    : null
                }
                <div className={styleClasses.join(' ')} ref={tabList => (this.tabList = tabList)}>
                    {tabs}
                </div>
                {this.showArrows ?
                    (this.currentTab === (this.props.tabList.length - 1)) ? null :
                        <div onClick={this.onTabNextClick} className={classes.TabButtonNext}>
                            <img src={HorizontalTabNextBlue} alt="Next Blue" />
                        </div>
                    : null
                }
            </div>
        );
    }
}

export default HorizontalTabs;